<template>
  <div>
    <button
      type="button"
      color="orange"
      outline
      class="pay-ass-btn green-button"
      v-if="
        details.assignmentStatus !== 4 &&
        details.assignmentStatus !== 7 &&
        details.isReadyForFinalPayment &&
        (details.customerCurrency === 'PKR'
          ? true
          : details.isPurchaseInvoiceGenerated) &&
        PendingAmount < 0
      "
      @click="check()"
    >
      Adjust
    </button>

    <v-dialog
      v-model="dialog"
      persistent
      content-class="adjust-payment-dialog"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="ap-card">
          <div class="ap-head">
            <span class="ap-head__icon"
              ><v-icon>account_balance_wallet</v-icon></span
            >
            <div class="ap-head__text">
              <strong>Adjust outstanding payment</strong>
              <span>Assignment {{ details.assignmentId }}</span>
            </div>
            <v-btn
              icon
              class="ap-head__close"
              :disabled="loading"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-progress-linear
            indeterminate
            color="orange"
            height="3"
            class="ap-progress"
            v-show="loading"
          ></v-progress-linear>

          <div class="ap-body">
            <div class="ap-section">
              <span class="ap-label">Adjustment type</span>
              <v-radio-group
                class="ap-modes"
                v-model="paymentMode"
                row
                :mandatory="true"
                :rules="[rules.required]"
                hide-details
                @change="emptyPopup()"
              >
                <v-radio
                  label="Collected cash from driver"
                  value="Cash"
                  color="orange"
                  :disabled="section === 'Assignment'"
                  class="ap-mode"
                ></v-radio>
                <v-radio
                  label="Adjust manually with assignment"
                  value="Manually"
                  :disabled="section === 'Accounts'"
                  color="orange"
                  class="ap-mode"
                ></v-radio>
                <v-radio
                  label="Loss to trukkin"
                  value="Lost"
                  :disabled="section === 'Assignment'"
                  color="orange"
                  class="ap-mode"
                ></v-radio>
              </v-radio-group>
            </div>

            <div class="ap-summary">
              <span class="ap-label">{{
                paymentMode === "Lost"
                  ? "Total amount to be lost"
                  : "Total amount to be adjusted"
              }}</span>
              <strong
                >{{
                  (
                    details.paymentAmount +
                    details.totalAdditionalAmount -
                    (details.totalAdvancePaidAmount -
                      this.adjustAmountAssignment) -
                    details.amountPaidToDriver
                  ).toFixed(2)
                }}
                <small>{{ details.customerCurrency }}</small></strong
              >
            </div>

            <div v-if="this.paymentMode === 'Cash'" class="ap-grid ap-grid--3">
              <div class="ap-field">
                <span class="ap-label">Amount to be adjusted *</span>
                <v-text-field
                  v-model="amountCollected"
                  type="number"
                  class="ap-input"
                  :value="amountCollected"
                  :suffix="details.customerCurrency"
                  placeholder="0.00"
                  :rules="[rules.required, rules.number]"
                ></v-text-field>
              </div>
              <div class="ap-field">
                <span class="ap-label">Date of collection *</span>
                <v-menu
                  ref="FilterDateBool"
                  lazy
                  v-model="FilterDateBool"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                  :return-value.sync="startDate"
                >
                  <v-text-field
                    slot="activator"
                    v-model="startDate"
                    prepend-inner-icon="event"
                    placeholder="Select date"
                    readonly
                    class="ap-input"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-date-picker
                    v-model="startDate"
                    :max="dateToday"
                    class="minHeight"
                    @change="$refs.FilterDateBool.save(startDate)"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="ap-field">
                <span class="ap-label">Time of collection *</span>
                <div class="ap-time">
                  <v-icon class="ap-time__icon">schedule</v-icon>
                  <vue-timepicker
                    class="ap-time__picker"
                    :minute-interval="30"
                    v-model="pickupTime"
                    input-width="100%"
                    placeholder="Select time"
                    :label="'Select actual time of collection'"
                    close-on-complete
                    :rules="[rules.required]"
                  ></vue-timepicker>
                </div>
              </div>
            </div>

            <div
              v-if="paymentMode === 'Manually' && this.AssignmentId.length"
              class="ap-grid ap-grid--manual"
            >
              <div class="ap-field">
                <span class="ap-label">Assignment *</span>
                <v-select
                  ref="ids"
                  :items="AssignmentId"
                  v-model="assignmentId"
                  class="ap-input"
                  placeholder="Select assignment"
                  return-object
                  :rules="[rules.required]"
                ></v-select>
              </div>
              <div class="ap-field">
                <span class="ap-label">Amount to be adjusted *</span>
                <v-text-field
                  v-model="amount"
                  class="ap-input"
                  type="number"
                  :value="amount"
                  :suffix="details.customerCurrency"
                  placeholder="0.00"
                  :rules="[rules.required, rules.number]"
                ></v-text-field>
              </div>
              <div class="ap-field">
                <span class="ap-label">Description *</span>
                <v-text-field
                  class="ap-input"
                  placeholder="Reason for this adjustment"
                  :rules="[rules.required, rules.noWhiteSpace]"
                  v-model="descrpition"
                ></v-text-field>
              </div>
              <div class="ap-field ap-field--action">
                <button type="button" class="ap-add-btn" @click="add">
                  <v-icon small>add</v-icon> Add
                </button>
              </div>
            </div>

            <div v-if="this.payment.length" class="ap-list">
              <div class="ap-list__head">
                <span>Assignment ID</span>
                <span>Amount collected from driver</span>
                <span>Description</span>
                <span></span>
              </div>
              <div
                v-for="(item, index) in payment"
                :key="item.id"
                class="ap-list__row"
              >
                <span class="ap-list__id">{{ item.id }}</span>
                <span
                  >{{ item.amount }} {{ details.customerCurrency }}</span
                >
                <span class="ap-list__desc">{{ item.descrpition }}</span>
                <button
                  type="button"
                  class="ap-remove-btn"
                  title="Remove"
                  @click="remove(index)"
                >
                  <v-icon small>close</v-icon>
                </button>
              </div>
            </div>

            <div v-if="this.paymentMode != 'Manually'" class="ap-field">
              <span class="ap-label">Description *</span>
              <v-text-field
                class="ap-input"
                placeholder="Reason for this adjustment"
                :rules="[rules.required, rules.noWhiteSpace]"
                v-model="comments"
              ></v-text-field>
            </div>

            <div v-if="!this.AssignmentId.length && isError" class="ap-error">
              <v-icon small>error_outline</v-icon>
              <span
                >Outstanding payment can't be adjusted as the driver doesn't
                have any ongoing assignment to adjust.</span
              >
            </div>
          </div>

          <div class="ap-actions">
            <v-btn
              flat
              class="ap-btn ap-btn--ghost"
              :disabled="loading"
              @click="close()"
              >Close</v-btn
            >
            <v-btn
              flat
              class="ap-btn ap-btn--primary"
              :disabled="
                loading ||
                (!this.assignmentIdList.length && section === 'Assignment')
              "
              @click="paymentMode === 'Manually' ? adjustManually() : pay()"
              >Adjust</v-btn
            >
          </div>
        </v-card>
        <v-snackbar
          :timeout="3000"
          bottom
          color="red darken-2"
          v-model="error"
          class="white--text"
          v-if="error"
          >{{ error }}</v-snackbar
        >
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { StorageKeys, CancellationType } from "../../../constants/constants";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import moment from "moment";
export default {
  props: {
    message: String,
    confirmationTitle: String,
    cancelBtn: String,
    confirmBtn: String,
    assignStatus: Number,
    section: String,
    details: Object,
    PendingAmount: Number,

    driverCreditDuration: Number,
  },
  components: {
    VueTimepicker,
  },
  data: () => ({
    loading: false,
    dateToday: moment(new Date()).format("YYYY-MM-DD"),
    paymentMode: "",
    isError: false,
    adjustAmountAssignment: 0,
    FilterDateBool: false,
    AssignmentId: [],
    assignmentId: null,
    assignmentIdList: [],
    descrpition: "",
    amount: null,
    payment: [],
    startDate: "",
    adjustAmount: null,
    // vue2-timepicker emits { HH, mm } for its default "HH:mm" format.
    pickupTime: {
      HH: "",
      mm: "",
    },
    startDate: "",
    ids: "",
    valid: true,
    lazy: false,
    amountCollected: null,
    cancellationType: CancellationType,
    rules: {
      required: (value) => !!value || "This field is required.",
      requiredObject: (v) =>
        v.hasOwnProperty("value") || "This field is required.",

      number: (value) => value > 0 || "Enter amount greater than zero.",
      requiredLength: (value) => !!value.length || "This field is required.",
      noWhiteSpace: (v) =>
        (v != null && v.trim().length > 0) || "This field is required.",
    },
    cancellationReason: "",
    cancelType: { text: "Other’s", value: "Other’s" },
    operationName: "",
    dialog: false,
    comments: "",
    error: null,
  }),
  created() {},
  methods: {
    assignmentList() {
      this.loading = true;
      this.isError = false;
      const data = {
        driverId: this.details.driverData.driverId.toString(),
        assignmentId: this.details._id,
      };

      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const { apiUrl } = this.constants;
      this.axios
        .post(`${apiUrl}/dmsAdmin/assignmentsToBeAdjusted`, data, config)
        .then(
          (response) => {
            response.data.data.forEach((e) => {
              this.AssignmentId.push({
                value: e._id,
                text: e.assignmentId,
              });
              this.assignmentIdList.push({
                value: e._id,
                text: e.assignmentId,
              });
            });
            setTimeout(() => {
              if (!this.AssignmentId.length) {
                this.isError = true;
              } else {
                this.isError = false;
              }
            }, 1000);

            this.loading = false;
          },

          (error) => {
            this.error = error.response.data.message;
            this.loading = false;
          }
        );
    },
    check() {
      if (
        this.$props.details.assetId &&
        this.$props.details.imeiInstallStatus &&
        this.$props.details.imeiInstallStatus != "collected"
      ) {
        this.dialog = false;
        this.error = "Kindly collect the gps device";
        this.$emit("close", true);
      } else if (
        this.$props.details.assetId &&
        !this.$props.details.imeiInstallStatus
      ) {
        this.dialog = false;
        this.error = "Kindly collect the gps device";
        this.$emit("close", true);
      } else {
        this.dialog = true;
        this.adjustAmountAssignment =
          this.details.amountAdjustedFromThisAssignment || 0;
        this.adjustAmount = Number(this.PendingAmount);

        if (this.$props.section === "Assignment") {
          this.assignmentList();
          this.paymentMode = "Manually";
        }
        if (this.section === "Accounts") {
          this.paymentMode = "Cash";
        } else {
          this.paymentMode = "Manually";
        }
        this.dialog = true;
      }
      // this.dialog = true;
    },
    emptyPopup() {
      this.comments = "";
      this.$refs.form.resetValidation();
      this.amountCollected = null;
      if (this.paymentMode === "Cash") {
        this.pickupTime = { HH: "", mm: "" };
        this.startDate = "";
      }
    },
    close() {
      this.dialog = false;
      this.comments = "";
      this.loading = false;
      this.adjustAmountAssignment = 0;

      this.$refs.form.resetValidation();
      if (this.paymentMode === "Manually") {
        this.amountCollected = null;
        this.amount = null;
        this.assignmentId = null;
        this.AssignmentId = [];
        this.descrpition = "";
        this.payment = [];
      }
      if (this.paymentMode === "Cash") {
        this.amountCollected = null;
        this.pickupTime = { HH: "", mm: "" };
        this.startDate = "";
      }
    },
    refreshList(i, selectedId) {
      for (let j = 0; j < this.payment.length; j++) {
        if (j != i) {
          var index = this.payment[j].assignmentList.findIndex(function (o) {
            return o.value === selectedId;
          });
          this.payment[j].assignmentList.splice(index, 1);
        }
      }
    },
    add() {
      if (this.$refs.form.validate()) {
        var collectedAmount = 0;
        if (this.payment.length >= 1) {
          for (let i = 0; i < this.payment.length; i++) {
            collectedAmount += Number(this.payment[i].amount);
          }

          if (
            Number(collectedAmount) + Number(this.amount) >
            Math.abs(this.adjustAmount)
          ) {
            this.error = "Amount can't be greater than to be collected amount";
            return;
          }
        } else {
          if (this.amount > Math.abs(this.adjustAmount)) {
            this.error = "Amount can't be greater than to be collected amount";
            return;
          }
        }

        this.payment.push({
          assignmentId: this.assignmentId.value,
          id: this.assignmentId.text,
          amount: this.amount,
          descrpition: this.descrpition,
        });

        let id = "";
        id = this.assignmentId.value;
        this.assignmentId = "";
        var index = this.AssignmentId.findIndex(function (o) {
          return o.value === id;
        });
        this.AssignmentId.splice(index, 1);
        this.descrpition = null;
        this.amount = null;
        this.$refs.form.resetValidation();
      }
    },
    remove(i) {
      this.AssignmentId.push({
        text: this.payment[i].id,
        value: this.payment[i].assignmentId,
      });
      let el = this.payment;
      el.splice(i, 1);
      this.payment = el;
    },

    checkTime() {
      const { HH, mm } = this.pickupTime || {};
      if (!HH || !mm) {
        this.error = "Please select time before moving ahead!";
        return false;
      }
      if (!/^\d{1,2}:\d{2}$/.test(HH + ":" + mm)) {
        this.error = "Please select the valid time before moving ahead!";
        return false;
      }
      return true;
    },
    adjustManually() {
      this.loading = true;
      if (!this.payment.length) {
        if (!this.$refs.form.validate()) {
          this.loading = false;
          return;
        }
      }

      if (this.paymentMode === "Manually") {
        if (
          !this.payment.length &&
          Number(this.amount) > Math.abs(this.adjustAmount)
        ) {
          this.loading = false;

          this.error = "Amount can't be greater than adjust amount";
          return;
        }
      }

      delete this.axios.defaults.headers.common["token"];
      let url = "/dmsAdmin/adjustAssignmentPayment";
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        assignmentId: this.details._id,
      };
      if (this.paymentMode === "Manually") {
        body.adjustedVia = "Assignment";

        let adjust = [];

        if (this.payment.length) {
          adjust = this.payment.map(({ assignmentId, amount, descrpition }) => {
            return { assignmentId, amount, descrpition };
          });

          body.assignmentIds = adjust;
        } else {
          let arr = [];
          arr.push({
            assignmentId: this.assignmentId.value,
            amount: this.amount,
            descrpition: this.descrpition,
          });
          body.assignmentIds = arr;
        }
      }
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.close();
          this.$emit("refresh-list");
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    pay() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.paymentMode === "Cash") {
          if (Math.abs(this.adjustAmount) < Number(this.amountCollected)) {
            this.loading = false;
            this.error = "Amount can't be greater than adjust amount";
            return;
          }

          if (!this.checkTime()) {
            this.loading = false;
            return;
          }
        }
        delete this.axios.defaults.headers.common["token"];
        let url = "/dmsAdmin/adjustAssignmentPayment";
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = { assignmentId: this.details._id };
        if (this.paymentMode === "Cash") {
          body.adjustedVia = "Return";
          body.amount = this.amountCollected;
          body.adjustedTime = this.pickupTime.HH + ":" + this.pickupTime.mm;
          body.adjustedDate = this.startDate;
          body.comment = this.comments.trim();
        } else if (this.paymentMode === "Lost") {
          body.adjustedVia = "Loss";
          body.amount = this.adjustAmount.toString();
          body.comment = this.comments.trim();
        }

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.close();
            this.$emit("refresh-list");
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.dashboard-style {
  color: grey;
  font-size: 18px;
  font-weight: 700;
}
.m-t-10 {
  margin-top: 10px;
}
.m-l-10 {
  margin-left: 10px;
}
.payy-ass-btn {
  color: #ffffff;
  background-color: #ea7a1c;
  border-radius: 5px;
  border: 2px solid #ea7a1c;
  padding: 2px 2px;
}
.text-style {
  font-size: 16px;
}
</style>

<style lang="scss">
/* Adjust outstanding payment popup (rendered at the app root by Vuetify). */
.application .v-dialog.adjust-payment-dialog {
  max-width: calc(100vw - 2rem) !important;
  overflow: visible !important;
  width: min(46rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-card {
  border-radius: 1rem !important;
  overflow: visible !important;
}

.application .v-dialog.adjust-payment-dialog .ap-head {
  align-items: center;
  background: var(--oms-peach, #fff7ed);
  border-bottom: 0.0625rem solid var(--oms-peach-border, #fed7aa);
  border-radius: 1rem 1rem 0 0;
  display: flex;
  gap: 0.75rem;
  padding: 1rem 0.75rem 1rem 1.25rem;
}

.application .v-dialog.adjust-payment-dialog .ap-head__icon {
  align-items: center;
  background: var(--oms-primary, #ea7a1c);
  border-radius: 0.75rem;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.application .v-dialog.adjust-payment-dialog .ap-head__icon .v-icon {
  color: #ffffff !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.adjust-payment-dialog .ap-head__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.application .v-dialog.adjust-payment-dialog .ap-head__text strong {
  color: var(--oms-navy, #1c2b5f);
  font-size: 1rem;
  font-weight: 800;
}

.application .v-dialog.adjust-payment-dialog .ap-head__text span {
  color: var(--oms-muted, #74716a);
  font-size: 0.8125rem;
}

.application .v-dialog.adjust-payment-dialog .ap-head__close.v-btn {
  align-self: flex-start;
  margin: -0.25rem 0 0 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-head__close .v-icon {
  color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-progress {
  margin: 0 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.125rem 1.25rem 1.25rem;
}

.application .v-dialog.adjust-payment-dialog .ap-label {
  color: var(--oms-ink, #3a382f);
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 0.375rem;
}

/* Adjustment type: three selectable cards. */
.application .v-dialog.adjust-payment-dialog .ap-modes.v-input {
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-modes .v-input--radio-group__input {
  display: grid !important;
  gap: 0.5rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.application .v-dialog.adjust-payment-dialog .ap-modes .ap-mode.v-radio {
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9);
  border-radius: 0.625rem;
  margin: 0 !important;
  min-height: 2.75rem;
  padding: 0.5rem 0.75rem;
}

.application .v-dialog.adjust-payment-dialog .ap-modes .ap-mode:has(input[aria-checked="true"]) {
  background: var(--oms-primary-soft, #fdf0e4);
  border-color: var(--oms-primary, #ea7a1c);
}

.application .v-dialog.adjust-payment-dialog .ap-modes .ap-mode.v-radio--is-disabled {
  opacity: 0.5;
}

.application .v-dialog.adjust-payment-dialog .ap-modes .ap-mode .v-label {
  color: var(--oms-ink, #3a382f) !important;
  font-size: 0.8125rem !important;
  font-weight: 700 !important;
  line-height: 1.3;
}

.application .v-dialog.adjust-payment-dialog .ap-summary {
  align-items: center;
  background: var(--oms-surface-soft, #faf9f6);
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.75rem;
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
}

.application .v-dialog.adjust-payment-dialog .ap-summary .ap-label {
  color: var(--oms-muted, #74716a);
  margin: 0;
}

.application .v-dialog.adjust-payment-dialog .ap-summary strong {
  color: var(--oms-ink-strong, #1a1916);
  font-size: 1.25rem;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
}

.application .v-dialog.adjust-payment-dialog .ap-summary strong small {
  color: var(--oms-muted, #74716a);
  font-size: 0.75rem;
  font-weight: 700;
}

.application .v-dialog.adjust-payment-dialog .ap-grid {
  align-items: start;
  display: grid;
  gap: 0.75rem;
}

.application .v-dialog.adjust-payment-dialog .ap-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.application .v-dialog.adjust-payment-dialog .ap-grid--manual {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.3fr) auto;
}

.application .v-dialog.adjust-payment-dialog .ap-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.application .v-dialog.adjust-payment-dialog .ap-field--action {
  padding-top: 1.375rem;
}

/* Boxed inputs; validation messages still show underneath. */
.application .v-dialog.adjust-payment-dialog .ap-input.v-input {
  font-size: 0.875rem !important;
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input .v-input__slot {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  margin: 0 !important;
  min-height: 2.625rem !important;
  padding: 0 0.75rem !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input .v-input__slot::before,
.application .v-dialog.adjust-payment-dialog .ap-input .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input.v-input--is-focused .v-input__slot,
.application .v-dialog.adjust-payment-dialog .ap-input.v-select--is-menu-active .v-input__slot {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input.error--text .v-input__slot {
  border-color: var(--oms-red, #be3b32) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input input,
.application .v-dialog.adjust-payment-dialog .ap-input .v-select__selection {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  -webkit-text-fill-color: var(--oms-ink-strong, #1a1916) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input input::placeholder {
  color: var(--oms-muted, #74716a) !important;
  font-weight: 500 !important;
  -webkit-text-fill-color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input .v-text-field__suffix {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input .v-input__prepend-inner {
  align-self: center !important;
  margin: 0 0.5rem 0 0 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input .v-input__prepend-inner .v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 1.125rem !important;
}

.application .v-dialog.adjust-payment-dialog .ap-input .v-text-field__details {
  margin: 0 !important;
  padding: 0.25rem 0.125rem 0 !important;
}

/* Time: vue-timepicker styled like the other inputs, icon inside. */
.application .v-dialog.adjust-payment-dialog .ap-time {
  position: relative;
}

.application .v-dialog.adjust-payment-dialog .ap-time__icon.v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 1.125rem !important;
  left: 0.75rem;
  pointer-events: none;
  position: absolute;
  top: 0.75rem;
  z-index: 4;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker {
  display: block !important;
  width: 100% !important;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker input.display-time {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  color: var(--oms-ink-strong, #1a1916) !important;
  font-family: inherit !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  height: 2.625rem !important;
  outline: none !important;
  padding: 0 2rem 0 2.25rem !important;
  -webkit-text-fill-color: var(--oms-ink-strong, #1a1916) !important;
  width: 100% !important;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker input.display-time::placeholder {
  color: var(--oms-muted, #74716a) !important;
  font-weight: 500 !important;
  -webkit-text-fill-color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker input.display-time:focus {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker .dropdown {
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.625rem;
  box-shadow: 0 0.75rem 2rem rgba(28, 43, 95, 0.18) !important;
  height: 12rem !important;
  overflow: hidden;
  top: calc(2.625rem + 0.25rem) !important;
  width: 100% !important;
  z-index: 20 !important;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker .dropdown .select-list {
  height: 12rem !important;
  width: 100% !important;
}

.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker .dropdown ul li:not([disabled]).active,
.application .v-dialog.adjust-payment-dialog .ap-time__picker.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.adjust-payment-dialog .ap-add-btn {
  align-items: center;
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem solid var(--oms-primary, #ea7a1c);
  border-radius: var(--oms-control-radius, 0.625rem);
  color: var(--oms-primary-dark, #d96a10);
  cursor: pointer;
  display: inline-flex;
  font-size: 0.8125rem;
  font-weight: 800;
  gap: 0.25rem;
  height: 2.625rem;
  padding: 0 0.875rem;
}

.application .v-dialog.adjust-payment-dialog .ap-add-btn .v-icon {
  color: inherit !important;
}

.application .v-dialog.adjust-payment-dialog .ap-add-btn:hover {
  background: var(--oms-primary-soft, #fdf0e4);
}

/* Added manual adjustments. */
.application .v-dialog.adjust-payment-dialog .ap-list {
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.75rem;
  overflow: hidden;
}

.application .v-dialog.adjust-payment-dialog .ap-list__head,
.application .v-dialog.adjust-payment-dialog .ap-list__row {
  align-items: center;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1.4fr) 2rem;
  padding: 0.5rem 0.875rem;
}

.application .v-dialog.adjust-payment-dialog .ap-list__head {
  background: var(--oms-surface-soft, #faf9f6);
  color: var(--oms-muted, #74716a);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.application .v-dialog.adjust-payment-dialog .ap-list__row {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  color: var(--oms-ink, #3a382f);
  font-size: 0.8125rem;
}

.application .v-dialog.adjust-payment-dialog .ap-list__id {
  font-weight: 700;
}

.application .v-dialog.adjust-payment-dialog .ap-list__desc {
  overflow-wrap: anywhere;
}

.application .v-dialog.adjust-payment-dialog .ap-remove-btn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0.5rem;
  color: var(--oms-muted, #74716a);
  cursor: pointer;
  display: inline-flex;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.application .v-dialog.adjust-payment-dialog .ap-remove-btn:hover {
  background: var(--oms-red-soft, #fbeae8);
  color: var(--oms-red, #be3b32);
}

.application .v-dialog.adjust-payment-dialog .ap-remove-btn .v-icon {
  color: inherit !important;
}

.application .v-dialog.adjust-payment-dialog .ap-error {
  align-items: flex-start;
  background: var(--oms-red-soft, #fbeae8);
  border: 0.0625rem solid var(--oms-red-border, #f0cfcc);
  border-radius: 0.625rem;
  color: var(--oms-red, #be3b32);
  display: flex;
  font-size: 0.8125rem;
  font-weight: 600;
  gap: 0.5rem;
  line-height: 1.4;
  padding: 0.625rem 0.75rem;
}

.application .v-dialog.adjust-payment-dialog .ap-error .v-icon {
  color: inherit !important;
}

.application .v-dialog.adjust-payment-dialog .ap-actions {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  gap: 0.625rem;
  justify-content: flex-end;
  padding: 0.875rem 1.25rem;
}

.application .v-dialog.adjust-payment-dialog .ap-btn.v-btn {
  border-radius: 0.625rem !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  height: 2.5rem !important;
  margin: 0 !important;
  min-width: 6rem !important;
  text-transform: none !important;
}

.application .v-dialog.adjust-payment-dialog .ap-btn--ghost.v-btn {
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.application .v-dialog.adjust-payment-dialog .ap-btn--primary.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.adjust-payment-dialog .ap-btn--primary.v-btn .v-btn__content {
  color: #ffffff !important;
}

.application .v-dialog.adjust-payment-dialog .ap-btn.v-btn--disabled {
  opacity: 0.55;
}

@media (max-width: 44rem) {
  .application .v-dialog.adjust-payment-dialog .ap-modes .v-input--radio-group__input,
  .application .v-dialog.adjust-payment-dialog .ap-grid--3,
  .application .v-dialog.adjust-payment-dialog .ap-grid--manual {
    grid-template-columns: minmax(0, 1fr);
  }

  .application .v-dialog.adjust-payment-dialog .ap-field--action {
    padding-top: 0;
  }
}
</style>
